import { render, staticRenderFns } from "./CategoryDropdown.vue?vue&type=template&id=7facf7cb&"
import script from "./CategoryDropdown.vue?vue&type=script&lang=js&"
export * from "./CategoryDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports